import { useTranslation } from 'react-i18next';
import { SubscriptionStatus } from '../hooks/useSubscriptionStatus';
import { clearSession } from '../auth/session';

interface Props {
  subscription: SubscriptionStatus;
}

export default function SubscriptionInactivePage({ subscription }: Props) {
  const { t } = useTranslation();
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'inventorygeek1@gmail.com';

  const logout = () => {
    clearSession();
    sessionStorage.clear();
    window.location.assign('/login');
  };

  return (
    <main className="subscription-blocked-page">
      <section className="subscription-blocked-card">
        <div className="subscription-blocked-icon" aria-hidden="true">!</div>
        <span className="subscription-blocked-status">
          {t(`subscription.statuses.${subscription.status || 'EXPIRED'}`)}
        </span>
        <h1>{t('subscriptionInactive.title')}</h1>
        <p className="subscription-blocked-lead">{t('subscriptionInactive.description')}</p>

        <div className="subscription-blocked-price">
          <strong>€50</strong>
          <span>{t('subscriptionInactive.perMonth')}</span>
        </div>

        <div className="subscription-blocked-steps">
          <h2>{t('subscriptionInactive.instructionsTitle')}</h2>
          <ol>
            <li>{t('subscriptionInactive.instructionContact')}</li>
            <li>{t('subscriptionInactive.instructionPayment')}</li>
            <li>{t('subscriptionInactive.instructionActivation')}</li>
          </ol>
        </div>

        <p className="subscription-blocked-note">{t('subscriptionInactive.dataSafe')}</p>
        <div className="subscription-blocked-actions">
          <a href={`mailto:${supportEmail}`}>{t('subscriptionInactive.contactSupport')}</a>
          <button type="button" onClick={logout}>{t('subscriptionInactive.logout')}</button>
        </div>
      </section>
    </main>
  );
}
